"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LazyValue = exports.StaticValue = void 0;
const ABSENT = Symbol('Absent');
class StaticValue {
    #value;
    constructor(value) {
        this.#value = value;
    }
    get() {
        return this.#value;
    }
}
exports.StaticValue = StaticValue;
class LazyValue {
    #provider;
    #memory = ABSENT;
    constructor(provider) {
        this.#provider = provider;
    }
    get() {
        if (this.#memory === ABSENT) {
            this.#memory = this.#provider();
        }
        return this.#memory;
    }
}
exports.LazyValue = LazyValue;
//# sourceMappingURL=Value.js.map